module.exports = __webpack_public_path__ + "media/img/features/audit-log-large-8687ca124fd835493c6e6854bf571191.png";